import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../page/layout'
import * as menu from '../core/menu'

Vue.use(Router)

// 解决：$router.push 跳转时如重复触发了同一个路由会报错：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx".
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

// 定义静态路由
const staticRoutes = [
    /** 公用页面 */
    {path: '/login', component: () => import('@/page/login')},
    {path: '/404', component: () => import('@/page/404')},
    {
        path: '/',
        component: Layout,
        redirect: '/welcome',
        children: [
            {
                path: 'welcome',
                component: () => import('@/page/welcome')
            }
        ]
    }
]

const router = new Router({
    routes: staticRoutes,
    mode: 'history'
})

// 定义动态路由：所有菜单页面及子页面对应的路由
function addDynamicRoutes() {
    // const menuList = store.state.session.menuList
    // 子路由未注册导致路由无法识别，加载所有有路由
    const menuList = menu.menuList
    menuList.forEach((item) => {
        if (item.menu_src && item.menu_src.trim() != '') {
            const route = {
                path: item.menu_src,
                component: Layout,
                children: [
                    {
                        path: '', // 子路由路径为空，表示默认子路由
                        component: () => import('@/page' + item.menu_src)
                    }
                ]
            }
            router.addRoute(route)
        }
    })

    // 添加 404 页面
    const notFoundRoute = {
        path: '*',
        redirect: '/404',
    }
    router.addRoute(notFoundRoute)
}

addDynamicRoutes()

// 监听 store.state.session.menuList 的变化，更新路由
// store.watch(
//     (state) => state.session.menuList,
//     (nv, ov) => {
//         if (JSON.stringify(nv) != JSON.stringify(ov)) {
//             addDynamicRoutes()
//         }
//     }
// )

export default router